import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';

@Component({
    selector: 'app-footer-medias',
    templateUrl: './footer-medias.component.html',
    styleUrls: ['./footer-medias.component.scss'], standalone: true,
    imports: [CommonModule, TranslateModule, MediaModule],

    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterMediasComponent {
    menu: Partial<MenuConfiguration> = StorageUtil.get<MenuConfiguration>('menu');
    @HostBinding('attr.aria-hidden') ariahidden = this?.menu?.footerMedias?.length > 0 ? null : '';
    @HostBinding('attr.aria-label') ariaLabel = this._translateService.instant('FOOTER.ACHIVEMENTS_LABEL')
    constructor(private _translateService: TranslateService) {}
}
